<template>
  <StandardLayout>
    <div slot="main">
      Player Layout
      <slot name="main" />
    </div>
  </StandardLayout>
</template>

<script>
import StandardLayout from '@/layouts/Standard.vue';

export default {

  name: 'PlayerLayout',

  components: {
    StandardLayout,
  },
}
</script>